import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";
import SelectorGrupos from "../../../common/SelectorGrupos";

function ReporteVentasArticulos() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_ARTICULOS_DEVOLUCIONES = process.env.REACT_APP_URL_ARTICULOS_DEVOLUCIONES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalCantidadDev, setTotalTotalCantidadDev] = useState(0);
  const [totalTotalCantidadVentaReal, setTotalTotalCantidadVentaReal] = useState(0);
  const [totalTotalCantidadEntregado, setTotalTotalCantidadEntregado] = useState(0);
  const [totalTotalCantidadPorEntregar, setTotalTotalCantidadPorEntregar] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
  const [totalTotalDineroBruto, setTotalTotalDineroBruto] = useState(0);
  const [totalTotalCosto, setTotalTotalCosto] = useState(0);
  const [totalTotalUtilidad, setTotalTotalUtilidad] = useState(0);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(false);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [activo, setActivo] = useState("");

  // Grupos de clientes elegidos antes de generar el reporte
  const [gruposSel, setGruposSel] = useState([]);
  const [gruposInfo, setGruposInfo] = useState([]);
  const [modalGrupos, setModalGrupos] = useState(true);
  const gruposQuery = gruposSel.length ? `?grupos=${gruposSel.join(",")}` : "";

  const confirmarGrupos = (ids, grupos) => {
    setGruposSel(ids);
    setGruposInfo(grupos);
    setModalGrupos(false);
  };

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

useEffect(() => {
  if (!gruposSel.length) return; // se genera hasta elegir grupos

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const round2 = (n) =>
    Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  // clave para devoluciones (SIN área, y precio = precioBruto del surtido)
  const keyDev = (idArticulo, idCliente, precioBruto) => {
    const pb = round2(precioBruto);
    return `${idArticulo}|${idCliente}|${pb}`;
  };

  const fetchAll = async () => {
    try {
      Toast.fire({ icon: "info", title: "Cargando..." });
      setCargando(true);

      const [ventasRes, devolRes, clientesRes, marcasRes, unRes] =
        await Promise.all([
          axios.get(
            `${URL_ARTICULOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}${gruposQuery}`,
            { headers }
          ),

          // ✅ devoluciones por fechas (back debe regresar: { idArticulo, idCliente, precio, cantidadDevuelta }
          axios.get(
            `${URL_ARTICULOS_DEVOLUCIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
            { headers }
          ),

          axios.get(URL_CLIENTES, { headers }),
          axios.get(URL_MARCAS, { headers }),
          axios.get(URL_UNIDADES_NEGOCIO, { headers }),
        ]);

      const allVentas = ventasRes.data ?? [];
      const allDevol = devolRes.data ?? [];

      // 1) Normaliza ventas
      const arrayTabla = allVentas
        .map((a) => {
          const precio = Number(a?.precio ?? 0);
          const precioBruto = Number(a?.precioBruto ?? 0);
          const cantidad = Number(a?.cantidad ?? 0);
          const entregado = Number(a?.entregadoCantidad ?? 0);
          const porEntregar = Number(a?.porEntregar ?? 0);
          const costoMX = Number(a?.costoUnitario ?? 0);

          return {
            SKU: a.articulos?.[0]?.SKU ?? "",
            nombre: a.articulos?.[0]?.nombre ?? "",
            marca: a.articulos?.[0]?.marcas?.[0]?.name ?? "",
            idMarca: String(a.articulos?.[0]?.marcas?.[0]?._id ?? ""),
            unidadNegocio: a.articulos?.[0]?.unidadesNegocio?.[0]?.name ?? "",
            idUnidadNegocio: String(
              a.articulos?.[0]?.unidadesNegocio?.[0]?._id ?? ""
            ),
            cliente: a.clientes?.[0]?.nombre_comercial ?? "",
            idCliente: String(a.clientes?.[0]?._id ?? ""),
            // El reporte se agrupa por GRUPO de clientes (no por almacen/area).
            // Se reutiliza el campo "area" para transportar el grupo del cliente.
            area: a.clientes?.[0]?.grupos?.[0]?.name ?? "Sin grupo",
            idArea: String(a.clientes?.[0]?.grupos?.[0]?._id ?? ""),
            idArticulo: String(a.articulos?.[0]?._id ?? ""),
            costoMX, // costo unitario
            precio,
            precioBruto,
            cantidad,
            entregado,
            porEntregar,
          };
        })
        .filter(Boolean);

      // 2) devMap: { "idArticulo|idCliente|precioDev": qtyDevuelta }
      // precioDev debe igualar precioBruto del surtido
      const devMap = allDevol.reduce((acc, d) => {
        const idArticulo = String(d.idArticulo ?? "");
        const idCliente = String(d.idCliente ?? "");
        const precioDev = round2(d.precio ?? 0);
        const qty = Number(d.cantidadDevuelta ?? 0);

        if (!idArticulo || !idCliente || !precioDev) return acc;

        const k = `${idArticulo}|${idCliente}|${precioDev}`;
        acc[k] = (acc[k] ?? 0) + qty;
        return acc;
      }, {});

      // 3) Agrupa ventas por: articulo|cliente|area|precio|precioBruto
      // y guarda total vendido por clave SIN área (para repartir devoluciones)
      const totalsSinArea = {};
      const agrupadoObj = arrayTabla.reduce((groups, item) => {
        const precioClave = round2(item.precio);
        const precioBrutoClave = round2(item.precioBruto);
        const key = `${item.idArticulo}|${item.idCliente}|${item.idArea}|${precioClave}|${precioBrutoClave}`;

        if (!groups[key]) {
          groups[key] = {
            idArticulo: item.idArticulo,
            idCliente: item.idCliente,
            idArea: item.idArea,
            precio: precioClave,
            precioBruto: precioBrutoClave,
            SKU: item.SKU,
            nombre: item.nombre,
            cliente: item.cliente,
            marca: item.marca,
            idMarca: item.idMarca,
            unidadNegocio: item.unidadNegocio,
            idUnidadNegocio: item.idUnidadNegocio,
            area: item.area,

            costoMX: Number(item.costoMX ?? 0), // costo unitario base

            // acumulados (BRUTOS)
            cantidad: 0,
            entregado: 0,
            porEntregar: 0,
            totalCosto: 0, // (bruto) costoUnitario * cantidad

            // 👇 devoluciones asignadas después
            cantidadDevuelta: 0,
          };
        }

        const grupo = groups[key];
        const costoUnitario = Number(item.costoMX ?? grupo.costoMX ?? 0);

        grupo.cantidad += item.cantidad;
        grupo.entregado += item.entregado;
        grupo.porEntregar += item.porEntregar;

        // costo bruto (para referencia)
        grupo.totalCosto += costoUnitario * item.cantidad;

        // total vendido por clave sin área (para repartir devoluciones)
        const kSinArea = keyDev(item.idArticulo, item.idCliente, precioBrutoClave);
        totalsSinArea[kSinArea] = (totalsSinArea[kSinArea] ?? 0) + item.cantidad;

        return groups;
      }, {});

      // 4) Repartir devoluciones por (articulo, cliente, precioBruto) ignorando área
      const grupos = Object.values(agrupadoObj);

      const gruposPorSinArea = grupos.reduce((acc, g) => {
        const k = keyDev(g.idArticulo, g.idCliente, g.precioBruto);
        (acc[k] = acc[k] ?? []).push(g);
        return acc;
      }, {});

      Object.entries(gruposPorSinArea).forEach(([kSinArea, lista]) => {
        const devTotal = Number(devMap[kSinArea] ?? 0);
        if (!devTotal) return;

        const vendidoTotal = Number(totalsSinArea[kSinArea] ?? 0);
        if (!vendidoTotal) return;

        let acumulado = 0;
        lista.forEach((g, idx) => {
          if (idx === lista.length - 1) {
            g.cantidadDevuelta = Math.max(0, devTotal - acumulado);
          } else {
            const parte = devTotal * (Number(g.cantidad ?? 0) / vendidoTotal);
            const asignada = Math.round(parte); // cambia a round2(parte) si quieres decimales
            g.cantidadDevuelta = asignada;
            acumulado += asignada;
          }
        });
      });

      // 5) Calcular métricas NETAS con cantidadVentaReal = cantidad - cantidadDevuelta
      const agrupadoValues = grupos
        .map((g) => {
          const costoUnitario = Number(g.costoMX ?? 0);

          const cantidad = Number(g.cantidad ?? 0);
          const cantidadDevuelta = Number(g.cantidadDevuelta ?? 0);
          const cantidadVentaReal = Math.max(0, cantidad - cantidadDevuelta);

          const precioUnit = Number(g.precio ?? 0);
          const precioBrutoUnit = Number(g.precioBruto ?? 0);

          // ✅ Totales netos
          const total = precioUnit * cantidadVentaReal;
          const totalBruto = precioBrutoUnit * cantidadVentaReal;

          // ✅ Costo neto
          const costoTotal = costoUnitario * cantidadVentaReal;

          // ✅ Utilidades netas
          const utilidad = total - costoTotal;
          const utilidadBruta = totalBruto - costoTotal;

          const utilidadPorcentaje = total ? (utilidad / total) * 100 : 0;
          const utilidadPorcentajeBruto = totalBruto
            ? (utilidadBruta / totalBruto) * 100
            : 0;

          return {
            ...g,

            // 👇 nuevo campo
            cantidadVentaReal,

            // promedios unitarios (igual a unitarios del grupo)
            precioPromedio: precioUnit,
            precioPromedioBruto: precioBrutoUnit,

            // netos
            total,
            totalBruto,

            // netos (para compatibilidad)
            costoTotal,
            totalCosto: costoTotal,

            // si en tu tabla usas estos nombres, déjalos netos también:
            totalPrecio: total,
            totalPrecioBruto: totalBruto,

            utilidad,
            utilidadBruta,

            utilidadPorcentaje: round2(utilidadPorcentaje),
            utilidadPorcentajeBruto: round2(utilidadPorcentajeBruto),
          };
        })
        .sort((a, b) => {
          if (a.SKU > b.SKU) return 1;
          if (a.SKU < b.SKU) return -1;
          if (a.precioBruto !== b.precioBruto) return a.precioBruto - b.precioBruto;
          return a.precio - b.precio;
        });

      setComments(agrupadoValues);

      setClientes(clientesRes.data ?? []);
      setMarcas(marcasRes.data ?? []);
      setUnidadesNegocio(unRes.data ?? []);

      setCargando(false);
      Toast.close();
    } catch (err) {
      console.log(err);
      setCargando(false);
      Toast.close();
    }
  };

  fetchAll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [gruposSel]);


function BuscaInfo() {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const round2 = (n) =>
    Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  // clave devoluciones (SIN área) y precio = precioBruto del surtido
  const keyDev = (idArticulo, idCliente, precioBruto) => {
    const pb = round2(precioBruto);
    return `${idArticulo}|${idCliente}|${pb}`;
  };

  setComments([]);
  setCargando(true);

  Promise.all([
    axios.get(
      `${URL_ARTICULOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}${gruposQuery}`,
      { headers }
    ),
    axios.get(
      `${URL_ARTICULOS_DEVOLUCIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
  ])
    .then(([ventasRes, devolRes]) => {
      const allVentas = ventasRes.data ?? [];
      const allDevol = devolRes.data ?? [];

      // 1) Normaliza ventas
      const arrayTabla = allVentas
        .map((a) => {
          const precio = Number(a?.precio ?? 0);
          const precioBruto = Number(a?.precioBruto ?? 0);
          const cantidad = Number(a?.cantidad ?? 0);
          const entregado = Number(a?.entregadoCantidad ?? 0);
          const porEntregar = Number(a?.porEntregar ?? 0);
          const costoMX = Number(a?.costoUnitario ?? 0);

          return {
            SKU: a.articulos?.[0]?.SKU ?? "",
            nombre: a.articulos?.[0]?.nombre ?? "",
            marca: a.articulos?.[0]?.marcas?.[0]?.name ?? "",
            idMarca: String(a.articulos?.[0]?.marcas?.[0]?._id ?? ""),
            unidadNegocio: a.articulos?.[0]?.unidadesNegocio?.[0]?.name ?? "",
            idUnidadNegocio: String(
              a.articulos?.[0]?.unidadesNegocio?.[0]?._id ?? ""
            ),
            cliente: a.clientes?.[0]?.nombre_comercial ?? "",
            idCliente: String(a.clientes?.[0]?._id ?? ""),
            // El reporte se agrupa por GRUPO de clientes (no por almacen/area).
            // Se reutiliza el campo "area" para transportar el grupo del cliente.
            area: a.clientes?.[0]?.grupos?.[0]?.name ?? "Sin grupo",
            idArea: String(a.clientes?.[0]?.grupos?.[0]?._id ?? ""),
            idArticulo: String(a.articulos?.[0]?._id ?? ""),
            costoMX,
            precio,
            precioBruto,
            cantidad,
            entregado,
            porEntregar,
          };
        })
        .filter(Boolean);

      // 2) devMap: "idArticulo|idCliente|precioDev" => cantidadDevuelta
      // precioDev debe igualar precioBruto del surtido
      const devMap = allDevol.reduce((acc, d) => {
        const idArticulo = String(d.idArticulo ?? "");
        const idCliente = String(d.idCliente ?? "");
        const precioDev = round2(d.precio ?? 0);
        const qty = Number(d.cantidadDevuelta ?? 0);

        if (!idArticulo || !idCliente || !precioDev) return acc;

        const k = `${idArticulo}|${idCliente}|${precioDev}`;
        acc[k] = (acc[k] ?? 0) + qty;
        return acc;
      }, {});

      // 3) Agrupa ventas IGUAL que antes (misma key con área),
      // pero guarda vendidos por key SIN área para poder repartir devoluciones
      const totalsSinArea = {};
      const agrupadoObj = arrayTabla.reduce((groups, item) => {
        const precioClave = round2(item.precio);
        const precioBrutoClave = round2(item.precioBruto);
        const key = `${item.idArticulo}|${item.idCliente}|${item.idArea}|${precioClave}|${precioBrutoClave}`;

        if (!groups[key]) {
          groups[key] = {
            idArticulo: item.idArticulo,
            idCliente: item.idCliente,
            idArea: item.idArea,
            precio: precioClave,
            precioBruto: precioBrutoClave,
            SKU: item.SKU,
            nombre: item.nombre,
            cliente: item.cliente,
            marca: item.marca,
            idMarca: item.idMarca,
            unidadNegocio: item.unidadNegocio,
            idUnidadNegocio: item.idUnidadNegocio,
            area: item.area,

            costoMX: Number(item.costoMX ?? 0),

            // acumulados (igual)
            cantidad: 0,
            entregado: 0,
            porEntregar: 0,
            totalPrecio: 0,
            totalPrecioBruto: 0,
            totalCosto: 0,

            // 👇 nuevo
            cantidadDevuelta: 0,
          };
        }

        const grupo = groups[key];
        const costoUnitario = Number(item.costoMX ?? grupo.costoMX ?? 0);

        grupo.cantidad += item.cantidad;
        grupo.entregado += item.entregado;
        grupo.porEntregar += item.porEntregar;
        grupo.totalPrecio += item.precio * item.cantidad;
        grupo.totalPrecioBruto += item.precioBruto * item.cantidad;
        grupo.totalCosto += costoUnitario * item.cantidad;

        // para repartir devoluciones (sin área)
        const kSinArea = keyDev(item.idArticulo, item.idCliente, precioBrutoClave);
        totalsSinArea[kSinArea] = (totalsSinArea[kSinArea] ?? 0) + item.cantidad;

        return groups;
      }, {});

      const grupos = Object.values(agrupadoObj);

      // 4) Repartir devoluciones ignorando área
      const gruposPorSinArea = grupos.reduce((acc, g) => {
        const k = keyDev(g.idArticulo, g.idCliente, g.precioBruto);
        (acc[k] = acc[k] ?? []).push(g);
        return acc;
      }, {});

      Object.entries(gruposPorSinArea).forEach(([kSinArea, lista]) => {
        const devTotal = Number(devMap[kSinArea] ?? 0);
        if (!devTotal) return;

        const vendidoTotal = Number(totalsSinArea[kSinArea] ?? 0);
        if (!vendidoTotal) return;

        let acumulado = 0;
        lista.forEach((g, idx) => {
          if (idx === lista.length - 1) {
            g.cantidadDevuelta = Math.max(0, devTotal - acumulado);
          } else {
            const parte = devTotal * (Number(g.cantidad ?? 0) / vendidoTotal);
            const asignada = Math.round(parte); // cambia a round2(parte) si quieres decimales
            g.cantidadDevuelta = asignada;
            acumulado += asignada;
          }
        });
      });

      // 5) Calcular métricas NETAS con cantidadVentaReal
      const agrupadoValues = grupos
        .map((g) => {
          const cantidad = Number(g.cantidad ?? 0);
          const cantidadDevuelta = Number(g.cantidadDevuelta ?? 0);
          const cantidadVentaReal = Math.max(0, cantidad - cantidadDevuelta);

          const precioUnit = Number(g.precio ?? 0);
          const precioBrutoUnit = Number(g.precioBruto ?? 0);
          const costoUnitario = Number(g.costoMX ?? 0);

          // netos
          const total = precioUnit * cantidadVentaReal;
          const totalBruto = precioBrutoUnit * cantidadVentaReal;
          const costoTotal = costoUnitario * cantidadVentaReal;

          const utilidad = total - costoTotal;
          const utilidadBruta = totalBruto - costoTotal;

          const utilidadPorcentaje = total ? (utilidad / total) * 100 : 0;
          const utilidadPorcentajeBruto = totalBruto
            ? (utilidadBruta / totalBruto) * 100
            : 0;

          return {
            ...g,

            // 👇 nuevo
            cantidadVentaReal,

            // promedios (por compatibilidad)
            precioPromedio: cantidad ? g.totalPrecio / cantidad : 0,
            precioPromedioBruto: cantidad ? g.totalPrecioBruto / cantidad : 0,

            // ✅ reemplazamos totales por netos (como pediste)
            total,
            totalBruto,
            costoTotal,
            totalCosto: costoTotal,

            // si tu UI usa estos, déjalos netos también
            totalPrecio: total,
            totalPrecioBruto: totalBruto,

            utilidad,
            utilidadBruta,
            utilidadPorcentaje: round2(utilidadPorcentaje),
            utilidadPorcentajeBruto: round2(utilidadPorcentajeBruto),
          };
        })
        .sort((a, b) => {
          if (a.SKU > b.SKU) return 1;
          if (a.SKU < b.SKU) return -1;
          if (a.precioBruto !== b.precioBruto) return a.precioBruto - b.precioBruto;
          return a.precio - b.precio;
        });

      setComments(agrupadoValues);
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
      setCargando(false);
      Toast.close();
    });
}


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          a.area,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalCosto),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedioBruto),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecioBruto),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.utilidad),
          new Intl.NumberFormat("en-US", {maximumFractionDigits: 2}).format(a.utilidadPorcentaje) + "%",
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);

    // Resumen por grupo (lo mismo que se muestra arriba)
    doc.autoTable({
      head: [["Grupo", "Cantidad de Articulos", "Venta (dinero)", "Utilidad Calculada", "% Utilidad"]],
      body: resumenPlataforma.map((r) => [
        r.Area,
        new Intl.NumberFormat("en-US").format(r.Cantidad),
        new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(r.Venta),
        new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(r.Utilidad),
        `${r.Porcentaje.toFixed(1)}%`,
      ]),
      startY: 45,
      styles: { fontSize: 9 },
    });

    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Grupo",
          "Cantidad",
          "Costo MX",
          "Costo Total",
          "Precio Promedio Bruto",
          "Precio Promedio Neto",
          "Total Bruto",
          "Total Neto",
          "Utilidad",
          "% Utilidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: doc.lastAutoTable.finalY + 8,
    });
    // doc.save(`Ventas.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

// function excel() {
//   // 1. Filtrado por cliente y marca
//   let filtered = comments.filter(
//     (a) =>
//       (selectedCliente === "" || selectedCliente === a.idCliente) &&
//       (selectedMarca === "" || selectedMarca === a.idMarca)&&
//         (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
//   );

//   // 2. Filtro por texto de búsqueda
//   if (search && search.trim() !== "") {
//     const searchLower = search.toLowerCase();
//     filtered = filtered.filter((a) =>
//       (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
//       (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
//       (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
//       (a.cliente && a.cliente.toLowerCase().includes(searchLower)) ||
//       (a.area && a.area.toLowerCase().includes(searchLower)) ||
//       (a.cantidad != null && a.cantidad.toString().includes(searchLower)) ||
//       (a.entregado != null && a.entregado.toString().includes(searchLower)) ||
//       (a.porEntregar != null && a.porEntregar.toString().includes(searchLower)) ||
//       (a.precioPromedio != null && a.precioPromedio.toString().includes(searchLower)) ||
//       (a.precioPromedioBruto != null && a.precioPromedioBruto.toString().includes(searchLower)) ||
//       (a.totalPrecioBruto != null && a.totalPrecioBruto.toString().includes(searchLower)) ||
//       (a.totalPrecio != null && a.totalPrecio.toString().includes(searchLower))
//     );
//   }

//   // 3. Mapear datos a exportar
//   const dataExcel = filtered.map((a) => ({
//     SKU: a.SKU,
//     Nombre: a.nombre,
//     Marca: a.marca,
//     Cliente: a.cliente,
//     Almacen: a.area,
//     Cantidad: a.cantidad,
//     Costo: Number(a.costoMX.toFixed(2)),
//     TotalCosto: Number(a.totalCosto.toFixed(2)),
//     PrecioPromedioBruto: Number(a.precioPromedioBruto.toFixed(2)),
//     PrecioPromedioNeto: Number(a.precioPromedio.toFixed(2)),
//     TotalBruto: Number(a.totalPrecioBruto.toFixed(2)),
//     TotalNeto: Number(a.totalPrecio.toFixed(2)),
//     Utilidad: Number(a.utilidad.toFixed(2)),
//     PorcentajeUtilidad: Number(a.utilidadPorcentaje.toFixed(2)),
//   }));

//   const dataExcelLimpia = dataExcel.filter((el) => el != null);

//   const option = {
//     fileName: "ReporteVentasArticulos",
//     datas: [
//       {
//         sheetData: dataExcelLimpia,
//         sheetName: "ReporteVentasArticulos",
//         sheetFilter: [
//           "SKU",
//           "Nombre",
//           "Marca",
//           "Cliente",
//           "Grupo",
//           "Cantidad",
//           "Costo",
//           "TotalCosto",
//           "PrecioPromedioBruto",
//           "PrecioPromedioNeto",
//           "TotalBruto",
//           "TotalNeto",
//           "Utilidad",
//           "PorcentajeUtilidad",
//         ],
//         sheetHeader: [
//            "SKU",
//           "Nombre",
//           "Marca",
//           "Cliente",
//           "Grupo",
//           "Cantidad",
//           "Costo",
//           "TotalCosto",
//           "PrecioPromedioBruto",
//           "PrecioPromedioNeto",
//           "TotalBruto",
//           "TotalNeto",
//           "Utilidad",
//           "PorcentajeUtilidad",
//         ],
//       },
//     ],
//   };

//   const toExcel = new ExportJsonExcel(option);
//   toExcel.saveExcel();
// }

function excel() {
  // 1. Filtrado por cliente y marca
  let filtered = comments.filter(
    (a) =>
      (selectedCliente === "" || selectedCliente === a.idCliente) &&
      (selectedMarca === "" || selectedMarca === a.idMarca)&&
      (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
  );

  // 2. Filtro por texto de búsqueda
  if (search && search.trim() !== "") {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter((a) =>
      (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
      (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
      (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
      (a.cliente && a.cliente.toLowerCase().includes(searchLower)) ||
      (a.area && a.area.toLowerCase().includes(searchLower)) ||
      (a.cantidad != null && a.cantidad.toString().includes(searchLower)) ||
      (a.entregado != null && a.entregado.toString().includes(searchLower)) ||
      (a.porEntregar != null && a.porEntregar.toString().includes(searchLower)) ||
      (a.precioPromedio != null && a.precioPromedio.toString().includes(searchLower)) ||
      (a.precioPromedioBruto != null && a.precioPromedioBruto.toString().includes(searchLower)) ||
      (a.totalPrecioBruto != null && a.totalPrecioBruto.toString().includes(searchLower)) ||
      (a.totalPrecio != null && a.totalPrecio.toString().includes(searchLower))
    );
  }

  // 3. Mapear datos a exportar
  const dataExcel = filtered.map((a) => ({
    SKU: a.SKU,
    Nombre: a.nombre,
    Marca: a.marca,
    Cliente: a.cliente,
    Grupo: a.area,
    Cantidad: a.cantidad,
    Costo: Number(a.costoMX.toFixed(2)),
    TotalCosto: Number(a.totalCosto.toFixed(2)),
    PrecioPromedioBruto: Number(a.precioPromedioBruto.toFixed(2)),
    PrecioPromedioNeto: Number(a.precioPromedio.toFixed(2)),
    TotalBruto: Number(a.totalPrecioBruto.toFixed(2)),
    TotalNeto: Number(a.totalPrecio.toFixed(2)),
    Utilidad: Number(a.utilidad.toFixed(2)),
    PorcentajeUtilidad: Number(a.utilidadPorcentaje.toFixed(2)),
  }));

  const dataExcelLimpia = dataExcel.filter((el) => el != null);

  // === 4. Agregar totales al final ===
  const totalCantidad = filtered.reduce((acc, a) => acc + Number(a.cantidad || 0), 0);
  const totalCosto = filtered.reduce((acc, a) => acc + Number(a.totalCosto || 0), 0);
  const totalBruto = filtered.reduce((acc, a) => acc + Number(a.totalPrecioBruto || 0), 0);
  const totalNeto = filtered.reduce((acc, a) => acc + Number(a.totalPrecio || 0), 0);
  const totalUtilidad = filtered.reduce((acc, a) => acc + Number(a.utilidad || 0), 0);
  const porcentajeUtilidadTotal = totalNeto > 0 ? Number(((totalUtilidad / totalNeto) * 100).toFixed(2)) : 0;
  dataExcelLimpia.push({
    SKU: "",
    Nombre: "",
    Marca: "",
    Cliente: "",
    Grupo: "TOTAL GENERAL",
    Cantidad: totalCantidad,
    Costo: "",
    TotalCosto: Number(totalCosto.toFixed(2)),
    PrecioPromedioBruto: "",
    PrecioPromedioNeto: "",
    TotalBruto: Number(totalBruto.toFixed(2)),
    TotalNeto: Number(totalNeto.toFixed(2)),
    Utilidad: Number(totalUtilidad.toFixed(2)),
    PorcentajeUtilidad: porcentajeUtilidadTotal,
  });

  // === Resumen por plataforma / cuenta (lo mismo que se muestra arriba) ===
  const resumenData = resumenPlataforma.map((r) => ({
    Grupo: r.Area,
    CantidadDeArticulos: r.Cantidad,
    Venta: Number((r.Venta || 0).toFixed(2)),
    UtilidadCalculada: Number((r.Utilidad || 0).toFixed(2)),
    PorcentajeUtilidad: Number((r.Porcentaje || 0).toFixed(2)),
  }));

  // === Exportar ===
  const option = {
    fileName: "ReporteVentasArticulos",
    datas: [
      {
        sheetData: resumenData,
        sheetName: "Resumen por Grupo",
        sheetFilter: ["Grupo", "CantidadDeArticulos", "Venta", "UtilidadCalculada", "PorcentajeUtilidad"],
        sheetHeader: ["Grupo", "Cantidad de Articulos", "Venta (dinero)", "Utilidad Calculada", "% Utilidad"],
      },
      {
        sheetData: dataExcelLimpia,
        sheetName: "ReporteVentasArticulos",
        sheetFilter: [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Grupo",
          "Cantidad",
          "Costo",
          "TotalCosto",
          "PrecioPromedioBruto",
          "PrecioPromedioNeto",
          "TotalBruto",
          "TotalNeto",
          "Utilidad",
          "PorcentajeUtilidad",
        ],
        sheetHeader: [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Grupo",
          "Cantidad",
          "Costo",
          "TotalCosto",
          "PrecioPromedioBruto",
          "PrecioPromedioNeto",
          "TotalBruto",
          "TotalNeto",
          "Utilidad",
          "PorcentajeUtilidad",
        ],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}



  function enviaMail() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas Articulo",
          email: mailTo,
          fileName: "ReporteVentasArticulos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte Ventas Articulo.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Grupo", field: "area", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Devoluciones", field: "cantidadDevuelta", sortable: true },
    { name: "Cantidad Real", field: "cantidadVentaReal", sortable: true },
    { name: "Costo", field: "costoMX", sortable: true },
    { name: "Total Costo", field: "totalCosto", sortable: true },
    // { name: "Cantidad Entregada", field: "entregado", sortable: true },
    // { name: "Cantidad Por Entregar", field: "porEntregar", sortable: true },
    { name: "Precio Promedio Bruto", field: "precioPromedioBruto", sortable: true },
    { name: "Precio Promedio Neto", field: "precioPromedio", sortable: true },
    { name: "Total Bruto", field: "totalPrecioBruto", sortable: true },
    { name: "Total Neto", field: "totalPrecio", sortable: true },
    { name: "Utilidad $", field: "utilidad", sortable: true },
    { name: "Utilidad %", field: "utilidadPorcentaje", sortable: true },
    
  ];


  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
        comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
        comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.cantidadDevuelta.toString().includes(search) ||
          comment.cantidadVentaReal.toString().includes(search) ||
          comment.entregado.toString().includes(search) ||
          comment.porEntregar.toString().includes(search) ||
          comment.precioPromedio.toString().includes(search) ||
          comment.precioPromedioBruto.toString().includes(search) ||
          comment.totalPrecioBruto.toString().includes(search) ||
          comment.totalPrecio.toString().includes(search) ||
          comment.costoMX.toString().includes(search) ||
          comment.totalCosto.toString().includes(search) ||
          comment.utilidad.toString().includes(search) ||
          comment.utilidadPorcentaje.toString().includes(search) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }

    if (selectedUnidadNegocio) {
      computedComments = computedComments.filter((e) =>
        e.idUnidadNegocio.includes(selectedUnidadNegocio)
      );
    }

    setTotalItems(computedComments.length);

    let cant = computedComments.map((c) => parseFloat(c.cantidad));
    let Tcant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidad(Tcant);

        let cantDev = computedComments.map((c) => parseFloat(c.cantidadDevuelta));
    let TcantDev = cantDev.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadDev(TcantDev);

    let cantVen = computedComments.map((c) => parseFloat(c.cantidadVentaReal));
    let TcantVen = cantVen.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadVentaReal(TcantVen);

    let cantEnt = computedComments.map((c) => parseFloat(c.entregado));
    let TcantEnt = cantEnt.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadEntregado(TcantEnt);

    let cantPor = computedComments.map((c) => parseFloat(c.porEntregar));
    let TcantPor = cantPor.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadPorEntregar(TcantPor);

    let totCos = computedComments.map((c) => parseFloat(c.totalCosto));
    let TtotCos = totCos.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCosto(TtotCos);

        let totUti = computedComments.map((c) => parseFloat(c.utilidad));
    let TtotUti = totUti.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalUtilidad(TtotUti);

    let cantTot = computedComments.map((c) => parseFloat(c.totalPrecio));
    let TcantTot = cantTot.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDinero(TcantTot);

    let cantTotBruto = computedComments.map((c) => parseFloat(c.totalPrecioBruto));
    let TcantTotBruto = cantTotBruto.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDineroBruto(TcantTotBruto);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "cantidadDevuelta" &&
      sorting.field != "cantidadVentaReal" &&
      sorting.field != "entregado" &&
      sorting.field != "porEntregar" &&
      sorting.field != "precioPromedio" &&
      sorting.field != "precioPromedioBruto" &&
      sorting.field != "totalPrecioBruto" &&
      sorting.field != "totalPrecio" &&
      sorting.field != "costoMX" &&
      sorting.field != "totalCosto" &&
      sorting.field != "utilidad" &&
      sorting.field != "utilidadPorcentaje"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "cantidad" ||
        sorting.field == "cantidadDevuelta" ||
        sorting.field == "cantidadVentaReal" ||
        sorting.field == "entregado" ||
        sorting.field == "porEntregar" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalCosto" ||
        sorting.field == "utilidad" ||
        sorting.field == "utilidadPorcentaje"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        sorting.field == "cantidad"||
        sorting.field == "cantidadDevuelta" ||
        sorting.field == "cantidadVentaReal" ||
        sorting.field == "entregado" ||
        sorting.field == "porEntregar" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalCosto" ||
        sorting.field == "utilidad" ||
        sorting.field == "utilidadPorcentaje"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedMarca,
    selectedUnidadNegocio,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  // Resumen: Venta total por plataforma y cuenta (agrupado por area)
  const resumenPlataforma = useMemo(() => {
    const g = {};
    comments.forEach((r) => {
      const id = r.idArea || "0";
      if (!g[id])
        g[id] = { idArea: id, Area: r.area || "Sin grupo", Cantidad: 0, Venta: 0, Utilidad: 0 };
      g[id].Cantidad += Number(r.cantidadVentaReal ?? r.cantidad ?? 0);
      g[id].Venta += Number(r.total ?? 0);
      g[id].Utilidad += Number(r.utilidad ?? 0);
    });
    return Object.values(g)
      .map((x) => ({ ...x, Porcentaje: x.Venta > 0 ? (x.Utilidad / x.Venta) * 100 : 0 }))
      .sort((a, b) => b.Venta - a.Venta);
  }, [comments]);

  return (
    <>
      <Header />
      <SelectorGrupos
        isOpen={modalGrupos}
        onConfirm={confirmarGrupos}
        onClose={() => setModalGrupos(false)}
        allowClose={gruposSel.length > 0}
        initialSelected={gruposSel}
      />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/ReportesBI"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte Ventas Articulo</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte Ventas Articulo por Grupo</h3>
          <div align="center" style={{ marginBottom: 8 }}>
            <small style={{ color: "#555" }}>
              Grupos: <b>{gruposInfo.map((g) => g.name).join(", ") || "—"}</b>{" "}
            </small>
            <Button size="sm" color="link" className="p-0" onClick={() => setModalGrupos(true)}>
              Cambiar grupos
            </Button>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={1}>
            <h4></h4>
            <Button
              size="sm"
              className="btn"
              id="botonListado"
              onClick={BuscaInfo}
              color={fechaModificada ? "danger" : "info"}
            >
              Actualizar
            </Button>
          </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Marcas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMarca}
                onChange={(e) => {
                  setSelectedMarca(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Unidad Negocio</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedUnidadNegocio}
                onChange={(e) => {
                  setSelectedUnidadNegocio(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {unidadesNegocio
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            {/* <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col> */}
          </Row>
          <br />

          {/* Resumen: Venta total por grupo */}
          <h4 align="center">Venta total por grupo</h4>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead className="thead-light">
              <tr>
                <th>Grupo</th>
                <th>Cantidad de Articulos</th>
                <th>Venta (dinero)</th>
                <th>Utilidad Calculada</th>
                <th>% Utilidad</th>
              </tr>
            </thead>
            <tbody>
              {resumenPlataforma.map((a) => (
                <tr>
                  <td>{a.Area}</td>
                  <td>{new Intl.NumberFormat("en-US").format(a.Cantidad)}</td>
                  <td>
                    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.Venta)}
                  </td>
                  <td style={{ color: a.Utilidad < 0 ? "#c62828" : "#2e7d32" }}>
                    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.Utilidad)}
                  </td>
                  <td style={{ color: a.Porcentaje < 0 ? "#c62828" : "#2e7d32" }}>
                    {a.Porcentaje.toFixed(1)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <h4 align="center">Detalle de venta por producto</h4>
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.SKU}</td>
                      <td>{a.nombre}</td>
                      <td>{a.marca}</td>
                      <td>{a.cliente}</td>
                      <td>{a.area}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.cantidadDevuelta)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.cantidadVentaReal)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalCosto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedioBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecioBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.utilidad)}</td>
                      <td>{new Intl.NumberFormat("en-US", {maximumFractionDigits: 2}).format(a.utilidadPorcentaje)}%</td>
                    </tr>
                  );
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidad)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidadDev)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidadVentaReal)}</td>
                {/* <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidadEntregado)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidadPorEntregar)}</td> */}
                <td></td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalCosto)}</td>
                <td></td>
                <td></td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDineroBruto)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDinero)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalUtilidad)}</td>
                  <td className="negrita">{((totalTotalUtilidad / totalTotalDinero) * 100).toFixed(2)}%</td>
              </tr>
            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ReporteVentasArticulos;
